/* WK nav: desktop dropdowns (hover + keyboard), mobile drawer + accordions, header height vars.
   No dependencies. Markup lives in sections/header-wk.liquid. */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 990px)');

  function setHeaderHeight(header) {
    var h = header.offsetHeight;
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', h + 'px');
  }

  /* ---------- desktop dropdowns ---------- */
  function initDropdowns(header) {
    var items = header.querySelectorAll('[data-wk-dropdown]');

    function setOpen(item, open) {
      var btn = item.querySelector('[data-wk-dropdown-toggle]');
      item.classList.toggle('is-open', open);
      if (open) item.classList.remove('is-closed');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      items.forEach(function (it) {
        if (it !== except) setOpen(it, false);
      });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-wk-dropdown-toggle]');
      var leaveTimer;

      item.addEventListener('mouseenter', function () {
        if (MOBILE_MQ.matches) return;
        clearTimeout(leaveTimer);
        item.classList.remove('is-closed');
        closeAll(item);
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', function () {
        leaveTimer = setTimeout(function () {
          setOpen(item, false);
        }, 120);
      });

      item.addEventListener('focusin', function (e) {
        if (item.contains(e.relatedTarget)) return; // moving within the item (e.g. Escape back to the link)
        item.classList.remove('is-closed');
        closeAll(item);
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          setOpen(item, false);
          item.classList.remove('is-closed');
        }
      });

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var open = !item.classList.contains('is-open');
          closeAll(item);
          setOpen(item, open);
          if (!open) item.classList.add('is-closed');
        });
      }

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          setOpen(item, false);
          item.classList.add('is-closed');
          var link = item.querySelector('.wk-nav__link');
          if (link) link.focus();
        }
        if (e.key === 'ArrowDown') {
          var first = item.querySelector('.wk-dropdown__link');
          var links = Array.prototype.slice.call(item.querySelectorAll('.wk-dropdown__link'));
          var idx = links.indexOf(document.activeElement);
          var next = idx === -1 ? first : links[Math.min(idx + 1, links.length - 1)];
          if (next) {
            e.preventDefault();
            setOpen(item, true);
            next.focus();
          }
        }
        if (e.key === 'ArrowUp') {
          var list = Array.prototype.slice.call(item.querySelectorAll('.wk-dropdown__link'));
          var i = list.indexOf(document.activeElement);
          if (i > 0) {
            e.preventDefault();
            list[i - 1].focus();
          } else if (i === 0) {
            e.preventDefault();
            item.querySelector('.wk-nav__link').focus();
          }
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer(header) {
    var openBtn = header.querySelector('[data-wk-drawer-open]');
    var drawer = header.querySelector('[data-wk-drawer]');
    if (!openBtn || !drawer) return;
    var closeBtn = drawer.querySelector('[data-wk-drawer-close]');

    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled])'),
        function (el) {
          return el.offsetParent !== null;
        }
      );
    }

    function open() {
      drawer.hidden = false;
      document.documentElement.classList.add('wk-drawer-open');
      openBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        drawer.classList.add('is-visible');
        if (closeBtn) closeBtn.focus();
      });
    }

    function close(returnFocus) {
      drawer.classList.remove('is-visible');
      document.documentElement.classList.remove('wk-drawer-open');
      openBtn.setAttribute('aria-expanded', 'false');
      drawer.hidden = true;
      if (returnFocus !== false) openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Close after following an in-page/anchor link so the page is visible.
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) close(false);
    });

    drawer.querySelectorAll('[data-wk-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });

    var onChange = function (e) {
      if (!e.matches && !drawer.hidden) close(false);
    };
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', onChange);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(onChange);
  }

  function init() {
    document.querySelectorAll('[data-wk-header]').forEach(function (header) {
      if (header.dataset.wkReady) return;
      header.dataset.wkReady = '1';
      initDropdowns(header);
      initDrawer(header);
      setHeaderHeight(header);
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { setHeaderHeight(header); }).observe(header);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init when the header section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
